import { render } from "./POS.vue?vue&type=template&id=7b3f971e&scoped=true"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"

import "./POS.vue?vue&type=style&index=0&id=7b3f971e&scoped=true&lang=css"
import "./POS.vue?vue&type=style&index=1&id=7b3f971e&lang=css"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3f971e"]])

export default __exports__